import { render } from "./mispadres2.vue?vue&type=template&id=248909e5&scoped=true"
import script from "./mispadres2.vue?vue&type=script&lang=js"
export * from "./mispadres2.vue?vue&type=script&lang=js"

import "./mispadres2.vue?vue&type=style&index=0&id=248909e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248909e5"]])

export default __exports__